// Copyright 2025. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const ChangeContainer = styled.div`
    margin-bottom: 14px;
`;
